import { cfpBaseUrl } from '../network/urls';

export const getComplaintAttachmentValue = (marker) => {
    if (!marker) return '';
    const value =
        marker.Attachment ??
        marker.attachment ??
        marker.complaitData?.Attachment ??
        marker.complaitData?.attachment ??
        '';
    return typeof value === 'string' ? value.trim().replace(/^\uFEFF/, '') : '';
};

export const getComplaintAttachmentImageSrc = (attachment) => {
    const raw = typeof attachment === 'string' ? attachment.trim().replace(/^\uFEFF/, '') : '';
    if (!raw || ['null', 'undefined'].includes(raw.toLowerCase())) {
        return '';
    }

    const lower = raw.toLowerCase();
    if (
        lower.startsWith('data:image') ||
        lower.startsWith('http://') ||
        lower.startsWith('https://') ||
        lower.startsWith('blob:')
    ) {
        return raw;
    }

    // Raw base64 (may include newlines/spaces from DB) — check before path heuristics
    // because base64 commonly contains '/' characters.
    const value = raw.replace(/\s/g, '');
    const looksLikeBase64 = value.length >= 32 && /^[A-Za-z0-9+/]+=*$/.test(value);
    if (looksLikeBase64) {
        let mime = '';
        if (value.startsWith('iVBORw0KGgo')) mime = 'image/png';
        else if (value.startsWith('/9j/')) mime = 'image/jpeg';
        else if (value.startsWith('R0lGOD')) mime = 'image/gif';
        else if (value.startsWith('UklGR')) mime = 'image/webp';
        else if (value.startsWith('JVBERi0')) return ''; // PDF — not an <img>
        else if (value.length > 100) mime = 'image/jpeg';

        if (mime) {
            return `data:${mime};base64,${value}`;
        }
    }

    // Relative/absolute file path returned by API
    if (raw.startsWith('/') || /\.(jpe?g|png|gif|webp|bmp)(\?.*)?$/i.test(raw)) {
        if (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('/')) {
            return raw;
        }
        const base = cfpBaseUrl.endsWith('/') ? cfpBaseUrl : `${cfpBaseUrl}/`;
        return `${base}${raw.replace(/^[/\\]+/, '')}`;
    }

    return '';
};

export const getMarkerAttachmentSrc = (marker) =>
    getComplaintAttachmentImageSrc(getComplaintAttachmentValue(marker));
